import { useQuery, useMutation } from "react-query";
import axios from "axios";
import { GetTokenFunc } from "../../utils/GetToken";
import { setAdminPortalType } from "../../utils/adminPortal";

export const LOGGED_IN_USER_QUERY_KEY = "LoggedInUser";

const GetLoggedInUser = async () => {
  const response = await axios.get("/api/v1/admin/getloggedinnuser", {
    headers: {
      authorization: `bearer ${GetTokenFunc()}`,
    },
  });
  return response.data;
};

export const useGetLoggedInUser = () => {
  return useQuery(LOGGED_IN_USER_QUERY_KEY, GetLoggedInUser, {
    staleTime: 0,
    cacheTime: 0,
    refetchOnMount: "always",
    onSuccess: (user) => {
      setAdminPortalType(user?.adminType);
    },
  });
};
